export default {
    brand: '매일국어T',

    // 기본 버튼들
    buttons: {
        addAllStar: 'ให้ดาวทั้งหมด',
        confirm: 'ยืนยัน',
        cancel: 'ยกเลิก',
        close: 'ปิด',
        next: 'ถัดไป',
        previous: 'ก่อนหน้า',
        start: 'เริ่ม',
        continue: 'ทำต่อ',
        stop: 'หยุด',
        exit: 'ออก',
        save: 'บันทึก',
        delete: 'ลบ',
        edit: 'แก้ไข',
        submit: 'ส่ง',
        reset: 'รีเซ็ต',
        selectAll: 'เลือกทั้งหมด',
        end: 'จบ',
        assign: 'กำหนด',
        auth: {
            login: 'เข้าสู่ระบบ',
            logout: 'ออกจากระบบ',
        },
    },

    // 공통 레이블
    labels: {
        module: 'กิจกรรม',
        lesson: 'ชุดกิจกรรม',
        star: 'ดาวชมเชย',
        waitingRoom: 'ห้องรอ',
        taskPage: 'รายการการบ้าน',
        screen: 'หน้าจอกระดาน',
        classroom: 'ห้องเรียน',
        student: 'นักเรียน',
        teacher: 'คุณครู',
        grade: 'ชั้นปี',
        school: 'โรงเรียน',
        name: 'ชื่อ',
        date: 'วันที่',
        time: 'เวลา',
        duration: 'ระยะเวลา',
        count: 'จำนวน',
        result: 'ผลลัพธ์',
        status: 'สถานะ',
        mode: 'โหมด',
        type: 'ประเภท',
        level: 'เลเวล',
        score: 'คะแนน',
        question: 'คำถาม',
        answer: 'คำตอบ',
        online: 'ออนไลน์',
        offline: 'ออฟไลน์',
        list: 'รายการ',
    },

    // 헤더 타이틀
    headerTitle: {
        waitingRoom: 'ห้องรอ',
    },

    // 공통 메시지
    messages: {
        confirm: 'ต้องการ{action}จริงหรือไม่?',
        success: '{action}เสร็จสมบูรณ์แล้ว',
        error: 'เกิดข้อผิดพลาด',
        networkError: 'เกิดข้อผิดพลาดของเครือข่าย',
        loading: 'กำลังโหลด...',
        noData: 'ไม่มีข้อมูล',
        selectOption: 'กรุณาเลือกตัวเลือก',
    },

    // 상태
    status: {
        inProgress: 'กำลังดำเนินการ',
        completed: 'เสร็จสิ้น',
        pending: 'รอดำเนินการ',
        failed: 'ล้มเหลว',
        locked: 'ล็อก',
        unlocked: 'ปลดล็อก',
    },

    // 교과 관련
    subject: {
        textbook: 'หนังสือเรียน',
        korean: 'ภาษาเกาหลี',
        koreanActivity: 'กิจกรรมภาษาเกาหลี',
        math: 'คณิตศาสตร์',
        science: 'วิทยาศาสตร์',
        socialStudies: 'สังคมศึกษา',
        english: 'ภาษาอังกฤษ',
    },

    // 화면/페이지 관련
    screen: {
        basic: 'หน้าจอหลัก',
        waitingRoom: 'ห้องรอ',
        activity: 'หน้าจอกิจกรรม',
        sessionResult: 'หน้าจอผลคาบเรียน',
        moduleResult: 'หน้าจอผลกิจกรรม',
    },

    // 시스템 메시지
    system: {
        networkError: {
            title: 'การเชื่อมต่ออินเทอร์เน็ตไม่ราบรื่น',
            message: 'กรุณารอสักครู่...',
            refresh: 'รีเฟรช',
        },
        windowError: {
            closeManually: 'เกิดข้อผิดพลาด กรุณาปิดหน้าต่างด้วยตนเอง',
        },
        audio: {
            playError: 'เกิดปัญหาขณะเล่นเสียง',
        },
    },

    // 접근성 (alt, title 등)
    accessibility: {
        alt: {
            starDraw: 'สุ่มดาว',
            seedLetter: 'ตัวอักษรเมล็ดพันธุ์',
            recentSessionResult: 'ผลคาบเรียนล่าสุด',
            questionImage: 'รูปภาพคำถาม',
            explanationImage: 'รูปภาพคำอธิบาย',
            photoMaterial: 'สื่อรูปภาพ',
        },
        title: {
            listen: 'ฟังเสียง',
            fold: 'พับหัวข้อการเขียน',
            close: 'ปิด',
        },
    },

    // 단위
    units: {
        minute: 'นาที',
        second: 'วินาที',
        page: 'หน้า',
        count: 'ชิ้น',
        person: 'คน',
        person2: 'คน',
        times: 'ครั้ง',
        level: 'เลเวล',
        chapter: 'คาบ',
        etc: 'อื่นๆ',
        vote: 'โหวต',
        notProvided: 'ไม่ได้ระบุ',
        score: 'คะแนน',
    },
    // teacher 컴포넌트를 끌어쓰는 경우
    common: {
        button: {
            cancel: 'ยกเลิก',
            confirm: 'ยืนยัน',
        },
    },
};
